module.exports = __webpack_public_path__ + "img/sleeve cuff width.53d5a05b.png";